import React from "react";
import Open from "./svg/Open";

interface BrandProps {
  id: string;
  name: string;
  url: string;
  path?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

const Brand: React.FC<BrandProps> = ({ name, url, path, onClick }) => {
  const completePath = path?.indexOf("/") !== 0 ? `/${path}` : path;
  const completeUrl = path?.length ? url + completePath : url;

  return (
    <a
      href={completeUrl}
      target="_BLANK"
      rel="noreferrer"
      onClick={onClick}
      className="transition-all flex justify-between bg-slate-300 hover:bg-slate-400 border rounded border-slate-400 justify-content-center p-3 mb-3 text-lg w-full items-center"
    >
      <div>
        <p className="font-medium text-sm">{name}:</p>
        <p className="text-xs">{completeUrl}</p>
      </div>
      <Open />
    </a>
  );
};

export default Brand;
